import { UserProfileModel } from '../typings/profile/profile';
import { StateModel } from './reducers';

export default class StoreHelper {
  static store: any;

  static getStore(): StateModel {
    return this.store.getState();
  }

  static setStore(store: any) {
    this.store = store;
  }

  static getUpload() {
    return this.store.getState().upload;
  }

  static getProfile(): UserProfileModel {
    return this.store.getState().auth.profileData;
  }

  static dispatch(f: any) {
    return this.store.dispatch(f);
  }
}
